import { useParams } from 'react-router-dom'

import { useAnalysisHistoryDetailApi } from '@/common/api/modules/mediaAnalysis'
import { CannibalizationAnalysis } from '@/common/model/media/articleCreator'
import { MediaAnalysisType } from '@/common/model/media/mediaAnalysis'

import CannibalizationPanel from '@/components/container/modules/media/articleCreator/CannibalizationPanel'

import MediaAnalysisResultPageBase from './MediaAnalysisResultPageBase'

// カニバリ分析結果
const MediaAnalysisCannibalizationResultPage = () => {
  const { siteId, historyId } = useParams()
  const sid = Number(siteId)
  const hid = Number(historyId)
  // 分析中（status=analyzing）の間は2秒間隔でポーリングし、完了したら自動的に停止する
  const { data, error } = useAnalysisHistoryDetailApi(
    siteId && historyId ? { site_id: sid, history_id: hid } : undefined,
    { refreshInterval: (latest) => (latest?.status === 'analyzing' ? 2000 : 0) }
  )

  const analysis = (data?.result_data ?? {}) as CannibalizationAnalysis

  return (
    <MediaAnalysisResultPageBase
      type={MediaAnalysisType.CANNIBALIZATION}
      data={data}
      error={error}
      resultError={analysis.error}
    >
      <CannibalizationPanel siteId={sid} historyId={hid} analysis={analysis} />
    </MediaAnalysisResultPageBase>
  )
}

export default MediaAnalysisCannibalizationResultPage
